import * as Ajax from './AjaxApi';

/**
 * Persist data to cache and return key string
 * @param {Object} config
 * @param {any} data
 * @param {any} c9log
 * @returns {Promise}
 */
export const saveToCache = async (config, data, c9log) => {
    const endpoint = config.endpoint.cache.url;
    try {
        return await Ajax.post(endpoint, data, config.endpoint.cache.headers);
    } catch (error) {
        c9log.error(`Failed when saving data to c9-cache ${error}`, 'ApplicationCache');
        return error;
    }
};

/**
 * Returns stored cache using key from url
 * @param {Object} config
 * @param {string} key
 * @param {any} c9log
 * @returns {Promise}
 */
export const restoreFromCache = async (config, key, c9log) => {
    // check if we have a document id passed as a parameter
    if (typeof key == 'string') {
        try {
            return await getCacheData(config, key, c9log);
        } catch (error) {
            c9log.error(`Unable to fetch receipt data ${error}`, 'ApplicationCache');
            window.location.href = '../';
        }
    }
};

/**
 * Retrieve receipt data
 * @param {Object} config
 * @param {string} receiptId
 * @param {any} c9log
 * @returns {Promise}
 */
const getCacheData = async (config, receiptId, c9log) => {
    const endpoint = `${config.endpoint.cache.url}/${receiptId}`;
    try {
        return await Ajax.get(endpoint, config.endpoint.cache.headers);
    } catch (error) {
        c9log.error(`Failed when loading data from c9-cache ${error}`, 'ApllicationCache');
        return Promise.reject(error);
    }
};
